import jwt_decode from "jwt-decode";
import {createRandomId} from "./random";
import { Auth} from "warded-lock/dist";

function getAuthConfig(): AuthConfig {
    return {
        authority: process.env.REACT_APP_AUTHORITY!,
        clientId: process.env.REACT_APP_CLIENT_ID!,
        callbackUrl: process.env.REACT_APP_REDIRECT_URI!,
        logoutUrl: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI!,
    };
}

export function getAuthManager(): Auth {
    const config = getAuthConfig();
    return new Auth({
        clientId: config.clientId,
        authority: config.authority,
        redirectUrl: config.callbackUrl,
    });
}

export interface AuthConfig {
    authority: string;
    callbackUrl: string;
    logoutUrl: string;
    clientId: string;
}

export class AppUser {
    user: any;

    constructor(user: any) {
        this.user = user;
    }

    static initialValue(): AppUser {
        return new AppUser({});
    }

    get id(): number {
        return parseInt(this.user.sub);
    }

    get displayName(): string {
        return this.user.name;
    }

    get role(): number {
        return parseInt(this.user["role"]);
    }

    hasAccessTo(claimCode: string): boolean {
        if (!this.user) {
            return true;
        }

        if (this.role === 1) {
            return true;
        }

        return this.user["access"]
            .split(",")
            .map((i: string) => i.toLowerCase())
            .includes(claimCode.toLowerCase());
    }
}
